export const PRACTICE_PLAYBACK_RATES = [0.5, 0.75, 0.8, 0.9, 1, 1.1, 1.2, 1.25, 1.5] as const

export type PracticePlaybackRate = (typeof PRACTICE_PLAYBACK_RATES)[number]

export const DEFAULT_PRACTICE_PLAYBACK_RATE: PracticePlaybackRate = 1

export function formatPlaybackRate(rate: number): string {
  if (rate === 1) return '1.0×'
  return `${Number(rate.toFixed(2))}×`
}
